export const API_SERVICES = {
  AUTH: "/auth",
  CORE: "/core",
  INTEGRATION: "/integration",
  MARKETING: "/marketing",
  BEHOLDER: "/beholder",
};
